import { useMemo } from "react";

import { useTireResults } from "../../useTireResults";
import { useTireBrands } from "./useTireBrands";

export const useTireBrandOptions = (): Option[] => {
  const { data: tires } = useTireResults({
    keepPreviousData: true,
  });
  const [selectedBrands] = useTireBrands();

  const options = useMemo((): Option[] => {
    if (!tires) return [];
    const acc = {} as Record<string, null>;
    for (const { partDetails } of tires.allParts) {
      const { tireManufacturerName } = partDetails.primaryPart;
      acc[tireManufacturerName] = null;
    }
    const entries = Object.entries(acc);
    const result = entries
      .map(([brand]) => {
        const count = tires.allParts.reduce(
          (acc, { partDetails }) =>
            partDetails.primaryPart.tireManufacturerName === brand
              ? acc + 1
              : acc,
          0
        );
        const checked = selectedBrands.includes(brand);
        return { brand, checked, count };
      })
      .sort((a, b) => a.brand.localeCompare(b.brand));
    return result;
  }, [tires?.allParts, selectedBrands]);
  return options;
};

type Option = {
  brand: string;
  checked: boolean;
  count: number;
};
